import clsx from 'clsx';
import React from 'react';

import Modal from '@mui/material/Modal';

import IconClose from './Images/Rebranding/IconClose';
import LogoTIWithIconTI from './Images/Rebranding/LogoTIWithIconTI';

export enum TiModalColorScheme {
  dark = 'dark',
  light = 'light',
}

interface TIModalProps {
  children: React.ReactNode;
  colorScheme?: TiModalColorScheme;
  customHeader?: boolean;
  customHeight?: boolean;
  disableScrollLock?: boolean;
  id?: string;
  isFullScreen?: boolean;
  isOpen: boolean;
  modalContainerClass?: string;
  onClose: () => void;
  parentClass?: string;
  withLogo?: boolean;
}

const TIModal = ({
  children,
  disableScrollLock,
  customHeader = false,
  customHeight = false,
  colorScheme = TiModalColorScheme.light,
  id,
  isFullScreen = false,
  isOpen,
  modalContainerClass,
  onClose,
  parentClass,
  withLogo = false,
}: TIModalProps) => {
  return (
    <Modal open={isOpen} onClose={onClose} disableScrollLock={disableScrollLock} id={id}>
      <div
        className={clsx(
          'outline-none',
          'absolute left-1/2 top-1/2 z-[1020] max-h-full -translate-x-1/2 -translate-y-1/2 rounded-2 dark:bg-[var(--light-grayscale-charcoal)]',
          parentClass,
          {
            'bg-grayscale-charcoal': colorScheme === TiModalColorScheme.dark,
            'bg-white': colorScheme === TiModalColorScheme.light,
            'h-screen max-w-full xs:h-auto': isFullScreen,
            'h-auto max-w-full px-16': !customHeight && !isFullScreen,
          }
        )}
      >
        <div
          className={clsx(modalContainerClass, 'modal-container relative', {
            'flex h-full justify-start xs:h-auto xs:justify-center': isFullScreen,
            'h-auto justify-center': !isFullScreen,
          })}
        >
          {!customHeader ? (
            <>
              <IconClose
                className={clsx(`close-button absolute right-0 top-16 w-20 cursor-pointer`, {
                  'text-black': colorScheme === TiModalColorScheme.light,
                  'text-white': colorScheme === TiModalColorScheme.dark,
                })}
                onClick={onClose}
                role="button"
                aria-pressed="false"
              />
              <div className="wrapper">
                {withLogo && (
                  <div className="logo-header">
                    <LogoTIWithIconTI className="w-[225px]" />
                  </div>
                )}
                {children}
              </div>
            </>
          ) : (
            <>{children}</>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default TIModal;
